import { Typography } from "antd";
import styles from "./candidateFieldLabel.module.scss";

const { Text } = Typography;

export const CandidateFieldLabel = ({ children, extra, required = false }) => {
  return (
    <div className={styles.fieldLabelContainer}>
      <Text className={styles.fieldLabel}>
        {`${children}:`}
        {required && <span className={styles.requiredMark}>*</span>}
      </Text>
      {extra && extra}
    </div>
  );
};
